import React from "react"

import styles from "./styles.css"

import { BLANK_ITEM_ID } from "../../constants"

export default function BlankItem(props) {
  const {
    getItemProps,
    item: { label, timeLabel },
    ...restProps
  } = props

  const { style: itemStyle, ...restItemProps } = getItemProps()

  const style = {
    ...itemStyle,
    borderRadius: `2px`,
    display: `flex`,
    pointerEvents: `none`,
    lineHeight: `normal`,
    minWidth: 2,
    boxShadow: `0 3px 4px 0 rgba(0, 0, 0, 0.12)`,
    zIndex: 2001, // between the modal background and window
  }

  return (
    <div
      eventid={BLANK_ITEM_ID}
      {...restItemProps}
      style={style}
      {...restProps}
    >
      <div className={styles[`custom-item`]}>
        <span className={styles[`item-title`]}>{label}</span>
        <span className={styles[`item-title`]}>{timeLabel}</span>
      </div>
    </div>
  )
}
